import React from 'react';

import { useSelector } from 'react-redux';
import Select, { Option, Overrides } from 'components/Select';

import { ShareFormField } from 'components/ShareForm';
import { tikTokPrivacyLevelOptionsSelector } from 'redux/modules/social';
import { block } from '../utils';
import TikTokVisibilityOption from './TikTokVisibilityOption';
import {
  formatVisibilityOptions,
  getSelectedOptionValue,
  getVisibilityOption,
} from './utils';

export interface TikTokVisibilitySelectorProps {
  value?: string;
  brandedContentSelected?: boolean;
  onChange: (value: string) => void;
}

const selectComponentOverrides: Overrides<Option> = {
  control: {
    props: p => ({
      ...p,
      className: p.className,
    }),
  },
  option: {
    component: TikTokVisibilityOption,
  },
};

const TikTokVisibilitySelector: React.FunctionComponent<TikTokVisibilitySelectorProps> = props => {
  const { value, brandedContentSelected, onChange } = props;

  const privacyLevelOptions = useSelector(tikTokPrivacyLevelOptionsSelector);

  const options = formatVisibilityOptions(
    privacyLevelOptions,
    brandedContentSelected ? ['selfOnly'] : [],
  );

  const handleSelectValue = React.useCallback(
    (option: Option): void => {
      const nextValue = getSelectedOptionValue(option);

      onChange(nextValue);
    },
    [onChange],
  );

  return (
    <ShareFormField
      label="Who can view your videos"
      className={block('form-field')}
    >
      <Select
        value={getVisibilityOption(options, value)}
        options={options}
        overrides={selectComponentOverrides}
        placeholder="Select an option"
        onChange={handleSelectValue}
      />
    </ShareFormField>
  );
};

export default TikTokVisibilitySelector;
